import React, { useEffect } from 'react';
import axios from 'axios';
import styles from '../styles/DisplayNotif.module.css';
import DisplayNotif from './DisplayNotif';
import { useNotifs } from '../../hooks/useNotifs';

import { useContext } from 'react';
import NotifContext from '../../context/NotifContext';

function NotifContainer() {
  const { status, togglePlayPause } = useContext(NotifContext);

const { notifs } = useNotifs();
console.log(notifs)
  return (
    // <div className={styles.FeedContainer}>

    //   {polls.polls && polls.polls.map(poll => <DisplayPoll key={poll.id} poll={poll} choices={polls.choices.filter((choice) => choice.poll === poll.id)}/>)}
    // </div>
    <>
        {notifs && notifs.map(notif => <a onClick={togglePlayPause} href={notif.link}><DisplayNotif key={notif.id} notif={notif} /></a>)}
    </>
  );
}

export default NotifContainer;